export function normalizeText(text: string): string {
  if (!text) return '';
  return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
}

export function formatDateDivider(dateObj: Date): string {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const targetDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
  const dayStr = dateObj.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long' });
  const weekDayStr = dateObj.toLocaleDateString('pt-BR', { weekday: 'long' });
  const capitalizedWeekDay = weekDayStr.charAt(0).toUpperCase() + weekDayStr.slice(1);

  if (targetDate.getTime() === today.getTime()) {
    return `Hoje • ${dayStr}`;
  } else if (targetDate.getTime() === yesterday.getTime()) {
    return `Ontem • ${dayStr}`;
  } else {
    return `${capitalizedWeekDay}, ${dayStr}`;
  }
}

export function formatFullTooltipDateTime(dateObj: Date): string {
  const timeStr = dateObj.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const dateStr = dateObj.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const weekDayStr = dateObj.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
  const capitalizedWeekDay = weekDayStr.charAt(0).toUpperCase() + weekDayStr.slice(1);

  return `${capitalizedWeekDay}, ${dateStr} às ${timeStr}`;
}

export function formatRecentTime(dateStr?: string | null): string {
  if (!dateStr) return '';
  const dateObj = new Date(dateStr);
  if (isNaN(dateObj.getTime())) return '';

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const targetDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());

  if (targetDate.getTime() === today.getTime()) {
    return dateObj.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  } else {
    return dateObj.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  }
}

export function escapeHtml(text: string): string {
  if (!text) return '';
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function formatPhoneNumber(phoneStr?: string | null): string {
  if (!phoneStr) return '';
  // Ignore WhatsApp LID identifiers (strings ending in @lid or 14-digit LID numbers)
  if (phoneStr.includes('@lid') || (phoneStr.length >= 14 && phoneStr.startsWith('14'))) {
    return '';
  }
  const digits = phoneStr.replace(/\D/g, '');
  if (!digits) return phoneStr;

  if (digits.startsWith('55') && digits.length >= 12) {
    const ddd = digits.slice(2, 4);
    const rest = digits.slice(4);
    if (rest.length === 9) {
      return `+55 ${ddd} ${rest.slice(0, 5)}-${rest.slice(5)}`;
    } else if (rest.length === 8) {
      return `+55 ${ddd} ${rest.slice(0, 4)}-${rest.slice(4)}`;
    }
  } else if (digits.startsWith('44') && digits.length >= 11) {
    return `+44 ${digits.slice(2, 6)} ${digits.slice(6)}`;
  } else if (digits.length >= 11 && !digits.startsWith('14')) {
    return `+${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
  }

  return `+${digits}`;
}
